import { MilestoneCalendar } from '@/components/milestones/MilestoneCalendar';

export default function CalendarPage() {
  return (
    <div className="container mx-auto p-6 max-w-7xl">
      <div className="mb-6">
        <h1 className="text-3xl font-bold">Milestone Calendar</h1>
        <p className="text-muted-foreground mt-2">
          View and track all milestones across your jobs in one place
        </p>
      </div>
      
      <MilestoneCalendar />
    </div>
  );
}
